import { AbstractControl } from '@angular/forms';
import { RegularExpressions } from '../text/regular-expressions';

export default function startWithALetter(control: AbstractControl) {
  if (control && control.value && control.value.length) {
    const value: string = control.value;
    if (!RegularExpressions.ALPHA_IGNORECASE.test(value[0])) {
      return {
        startWithALetter: true,
      };
    }
  }
  return null;
}
